import SquareTagsDefaultProps from "segments/desktop/core-components/square-tags/default-props.js";

export default SquareTagsDefaultProps;
